var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "29px",
    viewBox: "0 0 35 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4AD5ECEC-27A6-4D9F-B050-63BAA741FE57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-MVP/22",
    transform: "translate(-211.000000, -762.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectable-Card",
    transform: "translate(154.000000, 726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.237762, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Shipping",
    transform: "translate(27.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-sun-rise-455849",
    transform: "translate(10.909091, 15.454545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6305907,19.1691159 L29.8571611,19.1691159 C29.3852025,13.0378739 24.000906,8.18181818 17.4364889,8.18181818 C10.8725838,8.18181818 5.48809536,13.0376913 5.01581672,19.1691159 L0.915439827,19.1691159 C0.40923136,19.1691159 0,19.5597672 0,20.0398338 C0,20.5227368 0.409212162,20.9090909 0.915439827,20.9090909 L33.6300147,20.9090909 C34.1347193,20.9090909 34.5454545,20.5227186 34.5454545,20.0398338 C34.5454545,19.5609724 34.1347385,19.1691159 33.6300147,19.1691159 L33.6305907,19.1691159 Z M17.435529,9.92325404 C22.9933143,9.92325404 27.5594424,13.9966679 28.0266015,19.1691159 L6.84381663,19.1693536 C7.31127649,13.9967839 11.8788957,9.92349179 17.4348891,9.92349179 L17.435529,9.92325404 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8455445,23.6363636 L13.6104828,23.6363636 C13.1235473,23.6363636 12.7272727,24.0434207 12.7272727,24.5454545 C12.7272727,25.0519762 13.1249735,25.4545455 13.6104828,25.4545455 L21.8455445,25.4545455 C22.3353757,25.4545455 22.7272727,25.0519635 22.7272727,24.5454545 C22.7270316,24.0448975 22.3353571,23.6363636 21.8455445,23.6363636 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0418625,26.3636364 L15.4141362,26.3636364 C14.9352105,26.3636364 14.5454545,26.7706792 14.5454545,27.2712314 C14.5454545,27.7762458 14.9366133,28.1818182 15.4141362,28.1818182 L20.0418625,28.1818182 C20.5236363,28.1818182 20.9105442,27.7762649 20.9090909,27.2712314 C20.9090909,26.7706919 20.5221971,26.3636364 20.0418625,26.3636364 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1825814,7.27272727 C18.6886779,7.27272727 19.0909091,6.83719323 19.0909091,6.29840331 L19.0909091,0.974323958 C19.0909091,0.435554481 18.6871705,0 18.1825814,0 C17.6809563,0 17.2727273,0.435534048 17.2727273,0.974323958 L17.2727273,6.29840331 C17.2727273,6.83717279 17.6824256,7.27272727 18.1825814,7.27272727 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0201308,10 C30.2599381,10 30.4966955,9.90907549 30.6785848,9.7269664 L34.2733862,6.13283459 C34.636144,5.7686164 34.636144,5.18015591 34.2733862,4.8174722 C33.9121502,4.45478199 33.3205301,4.45478199 32.9577788,4.8174722 L29.3629774,8.41160401 C29.0002196,8.7758222 29.0002196,9.36428269 29.3629774,9.7269664 C29.5466422,9.90907549 29.7849278,10 30.0201308,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77458346,9.72691893 C4.95825709,9.90905969 5.19502579,10 5.4330692,10 C5.67136625,10 5.90965679,9.90905969 6.09155494,9.72844067 C6.45433017,9.36415916 6.45433017,8.77559636 6.09155494,8.41284959 L2.49684066,4.81809289 C2.13253708,4.45533962 1.54393863,4.45381138 1.1811699,4.81809289 C0.818401164,5.1823744 0.818394661,5.76944148 1.1811699,6.13368397 L4.77458346,9.72691893 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/Morning.07990f4d81bb8a4bd42e87378f494d57.svg";
export { ForwardRef as ReactComponent };